// Lead cells truncate at the column width; the title keeps the full text a hover away.
export const TextCell = ({ value }: { value: string }) => <span title={value}>{value}</span>;
